import { FC } from 'react';
import { ButtonStyled } from './style';
import { Props } from '@/components/tour/game/FinishScreen/styled/ButtonGroup/types';

const Button: FC<Props> = ({ show, children, ...restProps }) => {
  if (!show) return null;
  return <ButtonStyled {...restProps}>{children}</ButtonStyled>;
};

export default Button;
